import * as React from 'react';
import { Button } from "@material-ui/core";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import utilityBarStyles from './AlmeUtilityBar.styles';
import { WithStyles, withStyles } from '@material-ui/core/styles';
import { FocusComponentProps } from "../../models/ComponentProps";
import { AlmeUtilityBarConfig, UtilityBarLink } from "./AlmeUtilityBarConfig";


interface AlmeUtilityBarItemProps extends WithStyles<typeof utilityBarStyles> {
  almeConfig: AlmeUtilityBarConfig;
  focusProps?: FocusComponentProps;
  key: number;
  title?: string;
  links: UtilityBarLink[];
  onUtilityLinkClick: () => void;
}

function AlmeUtilityBarItem(props: AlmeUtilityBarItemProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const anchorRef = React.useRef<HTMLButtonElement>(null);


  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleRowClick = (event: Event | React.SyntheticEvent, link: UtilityBarLink) => {
    if (link.target === "_self") {
      props.onUtilityLinkClick();
    }
    window.open(link.href, link.target);
    handleClose();
  };

  return (
    <>
      <Button
        ref={anchorRef}
        size={"small"}
        className={props.classes.utilityBarButton}
        id={`alme-utility-button-${props.key}`}
        onClick={handleClick}
      >
        {props?.title}
      </Button>

      <Menu
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
        anchorEl={anchorEl}
      >
        {props.links.map((link, key) => {
          return (<MenuItem onClick={(e) => handleRowClick(e, link)}
            id={`alme-utility-button-${key}`}
            href={link.href}
            target={link.target}
            key={key}
          >
            {link.label}
          </MenuItem>);
        })}
      </Menu>
    </>
  );
}

export default withStyles(utilityBarStyles)(AlmeUtilityBarItem);
